import { render, staticRenderFns } from "./ScreenEmailPaciente.vue?vue&type=template&id=1d77694c&lang=true&"
import script from "./ScreenEmailPaciente.vue?vue&type=script&lang=js&"
export * from "./ScreenEmailPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports